<template>
	<div class="base_upload" :class="[showBorder ? 'border': '', `column_${column}`]">
		<van-uploader
			v-if="$route.query.uploadType === 'h5'"
			class="van_upload"
			:class="{ preview: preview }"
			v-model="fileList"
			:max-count="listLimit"
			:after-read="afterReadQiniu"
		/>

		<van-uploader
			v-else
			class="van_upload"
			:class="{ preview: preview }"
			v-model="fileList"
			:max-count="listLimit"
			readonly
			@click-upload="clickUpload"
		/>

		<van-action-sheet
			v-model="popupVisible"
			:actions="popupActions"
			cancel-text="取消"
			close-on-click-action
			@select="clickSelectPopup"
			@cancel="clickCancelPopup"
		/>
	</div>
</template>

<script>
	import { uploadQiniu } from '@/plugins/qiniu'
	export default {
		name: 'BaseUpload',
		props: {
			column: {
				type: [String, Number],
				default: 3
			},
			value: {
				type: Array,
				default: () => []
			},
			preview: {
				type: Boolean,
				default: false
			},
			limit: {
				type: [Number, String],
				default: 99999
			},
			showBorder: {
				type: Boolean,
				default: true
			}
		},
		data: () => ({
			popupVisible: false,
			popupActions: [
				{ name: '拍照上传', value: 'camera' },
				{ name: '相册选择', value: 'album' }
			],
			defaultCapture: ''
		}),
		computed: {
			fileList: {
				get () {
					return this.value
				},
				set (val) {
					this.$emit('input', val)
				}
			},
			listLimit() {
				if (this.preview) return this.value.length
				return this.limit
			}
		},
		methods: {
			clickUpload () {
				this.popupVisible = true
			},
			clickSelectPopup (val) {
				const _this = this
				window.wx.chooseImage({
					count: 1, // 默认9
					sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
					sourceType: [val.value], // 可以指定来源是相册还是相机，默认二者都有
					success ({ localIds }) {
						window.wx.uploadImage({
							localId: localIds[0],
							isShowProgressTips: 1,
							success ({ serverId }) {
								_this.uploadImg(serverId)
							}
						})
					}
				})
			},
			async uploadImg (serverId) {
				const res = await this.$api.account.getMediaFile(serverId)
				if (!res.code) {
					const list = JSON.parse(JSON.stringify(this.fileList))
					list.push({ url: res.data })
					this.fileList = list
				}
			},
			clickCancelPopup () {
				this.popupVisible = false
				this.defaultCapture = ''
			},
			afterReadQiniu(file) {
				file.status = 'uploading';
				file.message = '上传中';
				uploadQiniu(
					file.file,
					resolve => {
						file.url = resolve;
						file.status = 'done';
						file.message = '上传成功';
						const list = this.fileList.filter(file => file.status === 'done');
						this.$emit('success', list);
					},
					() => {
						file.status = 'failed';
						file.message = '上传失败';
					},
					() => {}
				)
			},
		}
	};
</script>

<style scoped lang="less"></style>
<style lang="less">
	.column_1_size {
		width: 100%;
		height: initial;
		margin-right: 0;
	}
	.column_2_size {
		width: 295px;
		height: 295px;
	}
	.column_3_size {
		width: 194px;
		height: 194px;
	}
	.column_4_size {
		width: 140px;
		height: 140px;
	}
	.base_upload {
		.van_upload {
			.van-uploader__upload {
				box-sizing: border-box;
				border-radius: 12px;
				background-color: #F5F6F7;
			}
			.van-uploader__preview {
				.van-uploader__preview-image{
					width: inherit;
					height: inherit;
					border-radius: 12px;
				}
				.van-uploader__preview-delete {
					border-radius: 50%;
					top: -10px;
					right: -10px;
					display: flex;
					justify-content: center;
					align-items: center;
					.van-uploader__preview-delete-icon {
						position: initial;
					}
				}
			}
			&.preview{
				.van-uploader__preview-delete{ display: none; }
			}
		}
		&.border {
			.van-uploader__upload {
				border: 1px solid #EEEEEE;
			}
		}
		&.column_1 {
			.van_upload {
				.van-uploader__upload { .column_3_size(); }
				.van-uploader__preview { .column_3_size(); }
			}
		}
		&.column_1 {
			.van_upload {
				.van-uploader__upload, .van-uploader__preview { .column_1_size(); }
			}
		}
		&.column_2 {
			.van_upload {
				.van-uploader__upload, .van-uploader__preview { .column_2_size(); }
			}
		}
		&.column_3 {
			.van_upload {
				.van-uploader__upload, .van-uploader__preview { .column_3_size(); }
			}
		}
		&.column_4 {
			.van_upload {
				.van-uploader__upload, .van-uploader__preview { .column_4_size(); }
			}
		}
	}
</style>
